module.exports = __webpack_public_path__ + "assets/img/ability22.1c26c825.png";